export default {"src":"/_next/static/media/stressMotivationMobile.7cb897fb.svg","height":233,"width":272,"blurWidth":0,"blurHeight":0};